export const parseError = (error: unknown | string | Error) => {
  if (!error) return ''
  const message = typeof error === 'string' ? error : (error as Error).message
  return message.replace(/Network error: |GraphQL error: |Node error: /g, '')
}
